var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoplayer-comp"},[_c('div',{ref:"container",staticClass:"videoplayer-container",style:({ flex: _vm.urn ? 1 : 0 })})])}
var staticRenderFns = []

export { render, staticRenderFns }